export class Slide {
    comments = [];
    content = [{
        title: '',
        text: ''
    }];
    feedback = [{
        text: ''
    }];
    intro = false;
    images = [];
    imagesMobile = [];
    outro = false;
    search = [];
    teaser = '';
    teaseToSlide;
    title = '';
    headers = [''];
    featured_media;
    metaTitle = '';
    metaDescription = '';
    status = 'draft';
    tags = [];
    type = 'slides';

    constructor(args) {
        this.setProperties(args);
    }
    setProperties(args) {
        for(var i in args) {
            this[i] = args[i];
        }
    }

}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/slide/slide.model.ts